var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 152 152",
    height: 512,
    viewBox: "0 0 152 152",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.6 141c10.6-.3 19-9.2 18.7-19.9-.3-10.2-8.5-18.4-18.7-18.7-10.6-.3-19.5 8.1-19.8 18.7-.3 10.7 8 19.5 18.7 19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.6 137.2c0 1.3-.1 2.5-.2 3.8h22.8c0-1.3.2-2.5.2-3.8-.3-44.3-36-80.2-80.2-80.5-1.3 0-2.5.1-3.8.2v22.9c1.3-.1 2.5-.2 3.8-.2 31.6.2 57.1 25.9 57.4 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2 11c-1.3 0-2.5.2-3.8.2v22.8c1.3 0 2.5-.2 3.8-.2 56.7.3 102.6 46.4 102.9 103.3 0 1.3-.1 2.5-.2 3.8h22.7c0-1.3.2-2.5.2-3.8-.2-69.5-56.3-125.9-125.6-126.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.b07b965e79f516619c2964d8bd04ebd3.svg";
export { ForwardRef as ReactComponent };